




























































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment-timezone'

import * as _ from 'underscore';
import { dateRangeInfoType } from '@/types/Common';

import { namespace } from "vuex-class";
import "@/store/modules/common";
const commonState = namespace("Common");


@Component
export default class BookingDateRangePicker extends Vue {
    
    @Prop({required: true})
    bookingRange!: dateRangeInfoType;

    @commonState.Action
    public UpdateCurrentDate!: (string) => void;

    onShow= false
    dates = []

    pickedDates=""
    pickerDateL=""
    pickerDateR=""
    startTime=''
    timeOptions = []
    endTime=''
    startTimeState = null
    endTimeState = null
    timeError = false
    startTimeError = false
    mobile = false;

    @Watch('pickerDateL')
    monthChange(newValue){
        this.pickerDateR = moment(newValue).add(1,'months').format("YYYY-MM")
    }

    @Watch('pickerDateR')
    monthChangeR(newValue){
        this.pickerDateL = moment(newValue).add(-1,'months').format("YYYY-MM")
    }
   

    mounted(){
        this.mobile = false;
        if (window.innerWidth < 600) {
            this.mobile = true;
        }
        this.timeError = false
        this.startTimeError = false
        this.initialTime()
        this.initDates()
    }


    public initialTime(){
        for(const time of [...Array(24).keys()]){            
            this.timeOptions.push(this.time24ToAmPm(time))            
        }
    }

    public initDates(){
        this.UpdateCurrentDate(moment().format("ddd MMM DD, YYYY HH:mm"));

        this.dates = []
     
        this.dates.push(this.bookingRange.startDate?.slice(0,10))
        this.dates.push(this.bookingRange.endDate?.slice(0,10))

        this.startTime = this.time24ToAmPm(this.bookingRange.startDate?.slice(11,13))
        this.endTime = this.time24ToAmPm(this.bookingRange.endDate?.slice(11,13))

        const newDates = this.CombineDateTime()
        this.getDatesText(newDates)

        if(this.bookingRange.startDate?.slice(0,7))
            this.pickerDateL = this.bookingRange.startDate.slice(0,7)
        else
            this.pickerDateL = moment().format("YYYY-MM")
    }


    public getDatesText(bookingDate){

        if(!bookingDate[1] || !bookingDate[0])
            this.pickedDates ='No dates'
        else
            this.pickedDates ='<b>From </b>'+ moment(bookingDate[0]).format("MMM DD, YYYY HH:mm") + (this.mobile? '<br>':' ')+
                              '<b>To </b>'+  moment(bookingDate[1]).format("MMM DD, YYYY HH:mm");      
    }

    public CombineDateTime(){
        this.dates = _.sortBy(this.dates)
        if(!this.dates[1] || !this.dates[0])
            return this.dates

        return [
            this.startTime? this.dates[0]+'T'+this.timeTo24h(this.startTime) :this.dates[0],
            this.endTime?   this.dates[1]+'T'+this.timeTo24h(this.endTime)   :this.dates[1]
        ]
    }

    public AddDates(){
        this.timeError = false
        this.startTimeError = false
        this.startTimeState = this.startTime? null : false
        this.endTimeState = this.endTime? null : false
        if(!this.startTime || !this.endTime) return 


        if(!this.dates[1] && !this.dates[0])
            this.setDatesToday()
        else if(!this.dates[0])
            this.dates[0] = this.dates[1]
        else if(!this.dates[1])
            this.dates[1] = this.dates[0]
        
        const newDates = this.CombineDateTime()

        this.getDatesText(newDates)

        if(newDates[0] >= newDates[1]){
            this.startTimeState =  false
            this.endTimeState =  false
            this.timeError = true
            return
        }
        const currentTime = moment().format()
        if(newDates[0] < currentTime){
            this.startTimeState =  false
            this.startTimeError = true
            return
        }

        const dateRange: dateRangeInfoType = {
            startDate:moment(newDates[0]).format() ,
            endDate:moment(newDates[1]).format()
        }

        this.$emit('datesAdded',dateRange)
        this.onShow= false
    }

    public focusSearchButton(){
        Vue.nextTick(()=>{
            const el = document.getElementsByName("search")[0];
            if(el) el.focus();
        })        
    }

    public timeTo24h(time){
        const timeParts = time.split(' ')
        if(timeParts[1]=='AM' && Number(timeParts[0])<10)
            return '0'+timeParts[0]+':00'
        if(timeParts[1]=='AM' && Number(timeParts[0])==12)
            return '00:00'
        if(timeParts[1]=='PM' && Number(timeParts[0])==12)
            return '12:00'
        if(timeParts[1]=='AM' && Number(timeParts[0])>=10)
            return timeParts[0]+':00'
        if(timeParts[1]=='PM')
            return (Number(timeParts[0])+12)+':00'

    }

    public time24ToAmPm(timeStr){
        
        if(timeStr||timeStr=='0'||timeStr==0){ 
            const time = Number(timeStr)
            if (time == 0){
                return '12 AM'
            } else if (time == 12) {
                return '12 PM'
            } else if (time<12) {
                return (time +' AM')
            } else {
                return (time-12 +' PM')
            }
        }
        return ''
    }



    public setDatesToday(){
        const today = moment().format("YYYY-MM-DD")        
        this.dates=[today, today]
        this.pickerDateL = moment().format("YYYY-MM")
    }

    public allowedDates(date){
        const day = moment(date).format()
        const current = moment().startOf('day').format()
        if(day<current) return false
        else return true
    }

    
}
